import { Stack, Typography } from '@mui/material';
import { useJITDisabled } from 'api/configurations';
import React from 'react';

const JITStatusFooter: React.FC = () => {
	const { data: jitDisabled } = useJITDisabled();

	return (
		<Stack
			data-testid="jit-status-footer"
			direction="row"
			alignItems="center"
			gap={0.5}
		>
			<Typography>
				{jitDisabled
					? intl.tr('home.jitBarButton.state.disabled')
					: intl.tr('home.jitBarButton.state.enabled')}
			</Typography>
		</Stack>
	);
};

export default JITStatusFooter;
